import React from "react"
import {Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {RootState} from "../../../Redux";
import {ServiceCardType} from "../Types";
import api from "../../../Services/api";

const { postCreateSpecial } = api.create();

interface TakeQueueNumberButtonProps {
    queueType: string
    setServiceCard: (serviceCard: ServiceCardType) => void
    setQueueNumber: (queueNumber: number) => void
}

const TakeQueueNumberButton = ({queueType, setServiceCard, setQueueNumber}: TakeQueueNumberButtonProps) => {
    const { t } = useTranslation()

    const chainId = useSelector((state: RootState) => state.ui.settings.chain.id)
    const stationId = useSelector((state: RootState) => state.ui.settings.station.id)

    async function getQueueNumber() {
        const response = await postCreateSpecial(
            chainId,
            stationId,
            queueType,
            {},
        )
        if (response.ok) {
            const serviceCard: ServiceCardType = response.data as ServiceCardType
            setServiceCard(serviceCard)
            setQueueNumber(serviceCard.queueNumber)
        } else {
            setQueueNumber(-1)
        }
    }

    return (
        <Button
            variant={"contained"}
            color="secondary"
            onClick={() => getQueueNumber()}
        >
            {t('selfService.takeQueueNumber')}
        </Button>
    )
}

export default TakeQueueNumberButton